// src/features/form/formSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isEdit: false,
  comapnyDetailsId: 0,
  jobDescriptionId: 0,
  detailsId: 0,
  companyId: '',
  companyName: "",
  industry: "",
  website: "",
  educationArea: '',
  companyType: "",
  companyLogo: "",
  companySize: "1-10",
  location: "",
  companyDescription: "",
  jobTitle: "",
  noOfPositions: "",
  department: "",
  locationJobDetails: "",
  anyLanguageOtherThanEnglish: "",
  jobType: "",
  workPlaceType: "",
  minEducationQualification: "",
  travelRequirement: "",
  descriptionAboutJob: "",
  jobDetails: "",
  keyFocus: "",
  experience: "",
  salary: "",
  employmentType: "Full-time",
  keywords: "",
  feedbackForJobDescription: "",
  jobCode: '',
  isSkippedQuiz: false,
  isAddQuizFromAddCode: false,
  backTodCodeUrlWithId: '',
  jdId: '',
  isView: false,
  viewBehavour: [],
  filteranalysis: '',

  //step
  step: 1,

  headerText: "Company Details",
  selectedKeywords: [],
  generatedJobDescription: '',
  RegeneratedJobDescription: '',
  finalSelectedJobDescription: '',
  generatedResponsibilities: [],
  regeneratedResponsibilities: [],
  finalSelectedResponsibilities: [],
  feedbackForJobResponsibilities: '',
  skillsRequiredForJob: [],
  topics: [],
  subTopics: [],
  allSubTopics: [],
  num_questions: 3,
  difficulty_level: 'medium',
  customTopics: {
    topics: [],
    subTopics: [],
    previousSubTopics: []
  },
  isTryToChangeBehaviour: false,
  behaviorsDataApi: {
    selectedByUser: [],
    selected: [],
    nonSelected: []
  },

  generatedCustomQuestions: [],
  generatedKeywordApiResponse: [],
  generatedKeywordsForUser: [],
  regeneratedKeywordsForUser: [],
  finalKeywordsForUser: [],
  feedbackForKeyWordsRegeneration: '',
  feedbackForJonDetailsRegeneration: '',
  jobDetailsRespArray: [],
  regeneratedJobDetailsArray: [],
  finalJobDetails: [],
  companyDetailsForJD: [],
  identifiedBehaviour: [],
  tempJobCode: '',
  allKeywords: [],
  behaviourQuestionsArray: [],
  answers: [],
  generatedSkillsArray: [],
  reGeneratedSkillsArray: [],
  finalSkillsArray: [],
  feedbackForSkillRegeneration: '',
  tTopics: [],
  tempJobCodeResp: {},
  generateBehaviourCompleteFlag: false,

  // flagToTriggerApiCallFromBehaviorPage : 

};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    updateFormField: (state, action) => {
      console.log(action);
      const { field, value } = action.payload;
      state[field] = value;
    },
    setFormData: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetFormData: () => initialState,

    setStep: (state, action) => {
      state.step = action.payload;
    },
    setHeaderText: (state, action) => {
      state.headerText = action.payload;
    },
    setSelectedKeywords: (state, action) => {
      state.selectedKeywords = action.payload;
    },
    setGeneratedJobDescription: (state, action) => {
      state.generatedJobDescription = action.payload;
    },
  },
});

export const { updateFormField, setFormData, resetFormData, setStep, setHeaderText, setSelectedKeywords, setGeneratedJobDescription } = formSlice.actions;
export default formSlice.reducer;
